import React from 'react';
const steps = ['Open', 'Print', 'Teach'];
export function SolutionSection() {
  return <section className="w-full bg-blush py-10 sm:py-12" aria-labelledby="solution-heading" data-id="element-137" data-mp="3aa13kaikcdv6">
      <div className="mx-auto max-w-4xl px-6" data-id="element-138" data-mp="3o9kbp3bdjp7h">
        <div className="rounded-4xl border border-gold/35 bg-cream px-7 py-11 text-center shadow-soft sm:px-14" data-id="element-139" data-mp="3o77jlxbwjygp">
          <p className="flex items-center justify-center gap-4 font-display text-lg italic text-gold" data-id="element-140" data-mp="3jck2wkn548co">
            <span className="h-px w-10 bg-gold/50" aria-hidden="true" data-id="element-141" data-mp="3t8ddvzl7ntsc" />
            Introducing
            <span className="h-px w-10 bg-gold/50" aria-hidden="true" data-id="element-142" data-mp="3t6kf16guaduw" />
          </p>

          <h2 id="solution-heading" className="mx-auto mt-4 max-w-2xl font-display text-4xl leading-[1.1] text-charcoal sm:text-5xl" data-id="element-143" data-mp="awi8qbov3njd">
            Ballet Teacher Elite System
          </h2>
          <p className="mx-auto mt-4 max-w-xl font-display text-2xl italic leading-snug text-wine" data-id="element-144" data-mp="fth04mh55gdv">
            The Most Comprehensive Teaching Library for Modern Educators.
          </p>

          <p className="mx-auto mt-7 max-w-readable font-sans text-base leading-relaxed text-ash" data-id="element-145" data-mp="36cyoe69kzkk6">
            This is not a random collection of exercises. It’s a{' '}
            <span className="font-medium text-wine" data-id="element-146" data-mp="3f9zbm9kwzcm1">
              Professional Master Library
            </span>{' '}
            organized by technical objectives and levels. No theory you have to
            rewrite. No videos you have to pause.
          </p>

          <ul className="mt-8 flex items-center justify-center gap-3 sm:gap-5" data-id="element-147" data-mp="3u7ro0sv5zkw0">
            {steps.map((step, index) => <li key={step} className="flex items-center gap-3 sm:gap-5" data-id="element-148" data-mp="2uf904c0496s" data-mpi={index}>
                <span className="font-display text-2xl text-charcoal sm:text-3xl" data-id="element-149" data-mp="6vqqtnomvq4f">
                  {step}
                </span>
                {index < steps.length - 1 ? <span className="h-1.5 w-1.5 rounded-full bg-rose-deep" aria-hidden="true" data-id="element-150" data-mp="gtevp6fyee0b" /> : null}
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}